import { useSelector } from "react-redux";

import { RootState } from "../../state/store";
import { LinkTarget } from "../../utilities/helpers/linkTarget";
import { hasArea } from "../../utilities/helpers/roleUtilities";

/**
 * The target if this user may follow it, otherwise null. Callers whose whole element exists only
 * for a live link (a chip, a button) branch on the result; content that shows either way, with or
 * without link-only extras, uses AccessLink.
 */
export const useAccessibleTarget = (target: LinkTarget | null | undefined): LinkTarget | null => {
  const { user } = useSelector((s: RootState) => s.authReducer);

  return target && hasArea(user, target.area) ? target : null;
};
